import { createSlice } from "@reduxjs/toolkit";

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    links: [],
    visible: false,
    open: false,
    isAnnounceCount: false,
  },
  reducers: {
    openSidebar: (state, action) => {
      state.open = action.payload;
    },
    showLinks: (state) => {
      state.visible = true;
    },
    hideLinks: (state) => {
      state.visible = false;
    },
    setLinks: (state, action) => {
      state.links = action.payload;
    },
    setAnnounceCount: (state, action) => {
      state.isAnnounceCount = action.payload;
    },
    resetSelectedLink: (state) => {
      const updatedLinks = state.links.map((link) => ({
        ...link,
        selected: false,
      }));
      state.links = updatedLinks;
    },
    resetLinks: (state) => {
      state.links = [];
    },
  },
});

// this is for dispatch
export const {
  setLinks,
  resetLinks,
  showLinks,
  hideLinks,
  openSidebar,
  resetSelectedLink,
  setAnnounceCount,
} = sidebarSlice.actions;

// this is for configureStore
export default sidebarSlice.reducer;
